// extracted by mini-css-extract-plugin
export default {"pageWrapper":"ScanTableBarcodePage_pageWrapper__J5pMN","title":"ScanTableBarcodePage_title__2H3pp"};